// Styles
import { Link } from "react-router-dom";
import styled from "styled-components";
// Images
import { hoobank_small, vidoeGame_small, sprout_scribble_small } from "../img/";
// Animation
import { motion } from "framer-motion";
import {
  fade,
  lineAnim,
  pageAnimation,
  photoAnim,
  slider,
  sliderContainer,
} from "../animation";
import { useScroll } from "../components/useScroll";
// Scroll at the Top of the window
import ScrollTop from "../components/ScrollTop";
import { primaryColor } from "../components/GlobalStyle";
import React, { useState, useEffect } from "react";

const OurWork = () => {
  const [element1, controls1] = useScroll();
  const [element2, controls2] = useScroll();
  const [element3, controls3] = useScroll();
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    setShowContent(false);
    const timer = setTimeout(() => setShowContent(true), 1600); // adjust to match slider animation duration
    return () => clearTimeout(timer);
  }, []);

  return (
    <Work
      // style={{ background: "#fff" }}
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      exit="exit"
    >
      <motion.div variants={sliderContainer}>
        <Frame1 variants={slider}></Frame1>
        <Frame2 variants={slider}></Frame2>
        <Frame3 variants={slider}></Frame3>
        <Frame4 variants={slider}></Frame4>
      </motion.div>
      {showContent && (
        <>
          <Movie
            variants={fade}
            initial="hidden"
            animate={controls1}
            ref={element1}
          >
            <motion.h2 variants={fade}>The Hoobank</motion.h2>
            <motion.div variants={lineAnim} className="line"></motion.div>
            <Link to="/work/the-hoobank">
              <Hide>
                <motion.img
                  variants={photoAnim}
                  src={hoobank_small}
                  alt="Image"
                />
              </Hide>
            </Link>
          </Movie>
          <Movie
            variants={fade}
            initial="hidden"
            animate={controls2}
            ref={element2}
          >
            <motion.h2 variants={fade}>The Game Hub</motion.h2>
            <motion.div variants={lineAnim} className="line"></motion.div>
            <Link to="/work/the-vidoeGame">
              <Hide>
                <motion.img
                  variants={photoAnim}
                  src={vidoeGame_small}
                  alt="Image"
                />
              </Hide>
            </Link>
          </Movie>
          <Movie
            variants={fade}
            initial="hidden"
            animate={controls3}
            ref={element3}
          >
            <motion.h2 variants={fade}>Sprout-scribble</motion.h2>
            <motion.div variants={lineAnim} className="line"></motion.div>
            <Link to="/work/the-sprout-scribble">
              <Hide>
                <motion.img
                  variants={photoAnim}
                  src={sprout_scribble_small}
                  alt="Image"
                />
              </Hide>
            </Link>
          </Movie>
        </>
      )}
      <ScrollTop />
    </Work>
  );
};

const Work = styled(motion.div)`
  min-height: 100vh;
  overflow: hidden;
  padding: 5rem 10rem;

  h2 {
    padding: 1rem 0rem;
    color: #cccccc;
  }

  @media (max-width: 1300px) {
    padding: 3rem 5rem;
  }

  @media (max-width: 768px) {
    padding: 2rem 2rem;
    min-height: auto;
  }

  @media (max-width: 480px) {
    padding: 1.5rem 1rem;
  }
`;

const Movie = styled(motion.div)`
  padding-bottom: 10rem;

  .line {
    height: 0.5rem;
    margin-bottom: 3rem;
    background: ${primaryColor};
  }

  img {
    width: 100%;
    height: 70vh;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    padding-bottom: 5rem;

    img {
      height: 50vh;
    }
  }

  @media (max-width: 480px) {
    img {
      height: 40vh;
    }
  }
`;

const Hide = styled.div`
  overflow: hidden;
`;

// Frame Animation
const Frame1 = styled(motion.div)`
  position: fixed;
  left: 0%;
  top: 10%;
  background: #fffebf;
  width: 100%;
  height: 100vh;
  z-index: 2;
`;

const Frame2 = styled(Frame1)`
  background: #ff8efb;
`;

const Frame3 = styled(Frame1)`
  background: #8effa0;
`;

const Frame4 = styled(Frame1)`
  background: #8ed2ff;
`;

export default OurWork;
